import { abilityGroups } from '@/lib/build-planner';
import { getPage } from '@/lib/content-registry';
import { m } from '@/paraglide/messages.js';
import { getLocale } from '@/paraglide/runtime.js';
import { BuildPlanner } from '@/components/control-resonant/build-planner';
import { chineseTerm } from '@/content/locales/zh-CN/glossary';

import { ContentBlock } from './control-content';

export function PlannerBlock() {
  return (
    <ContentBlock
      page={getPage('/build-planner')!}
      tool={
        <BuildPlanner
          names={
            getLocale() === 'zh'
              ? {
                  ...Object.fromEntries(
                    [
                      ...abilityGroups.flatMap((group) => [
                        group.name,
                        ...group.options.map((option) => option.name),
                      ]),
                      'Command',
                    ].map((name) => [name, chineseTerm(name)])
                  ),
                  Projectiles: m['control.tags.projectiles'](),
                  Summons: m['control.tags.summons'](),
                  Defense: m['control.tags.defense'](),
                  Aerial: m['control.tags.aerial'](),
                  Control: m['control.tags.control'](),
                  'Weapon support': m['control.tags.weapon'](),
                  'Short-range fire': m['control.tags.close_fire'](),
                }
              : {}
          }
          labels={{
            clear: m['control.planner.clear'](),
            reset: m['control.planner.reset'](),
            copy: m['control.planner.copy'](),
            copied: m['control.planner.copied'](),
            summary: m['control.planner.summary'](),
            empty: m['control.planner.empty'](),
            selected: m['control.planner.selected'](),
            fixed: m['control.planner.fixed'](),
            command: m['control.planner.command'](),
            storage: m['control.planner.storage'](),
            manual: m['control.planner.manual'](),
            link: m['control.planner.link'](),
            tags: m['control.planner.tags'](),
          }}
        />
      }
    />
  );
}
